import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {Group, Item} from '@pb/kit-component-group';
import {Body, Cell, Head, Row, Table} from '@pb/kit-component-table';

export const PermissionsTableSkeleton = () => (
    <Table>
        <Head>
            <Cell width={38}/>
            <Cell width={430}><SkeletonItem width={150} height={18}/></Cell>
            <Cell>
                <Group gap="none" justify="space-around">
                    <SkeletonItem width={50} height={18}/>
                    <SkeletonItem width={50} height={18}/>
                    <Item className="pdx-m">
                        <SkeletonItem width={50} height={18}/>
                    </Item>
                    <SkeletonItem width={50} height={18}/>
                    <SkeletonItem width={70} height={18}/>
                </Group>
            </Cell>
        </Head>
        <Body>
            {Array.from({length: 15}, (permission, i) => (
                <Row key={i}>
                    <Cell width={38}/>
                    <Cell><SkeletonItem width={150} height={18}/></Cell>
                    <Cell>
                        <Group gap="none" justify="space-around">
                            <SkeletonItem circle={true} width={14} height={14}/>
                            <SkeletonItem circle={true} width={14} height={14}/>
                            <SkeletonItem circle={true} width={14} height={14}/>
                            <SkeletonItem circle={true} width={14} height={14}/>
                            <SkeletonItem circle={true} width={14} height={14}/>
                        </Group>
                    </Cell>
                </Row>
            ))}
        </Body>
    </Table>
);
